module.exports = __webpack_public_path__ + "static/media/85.5f77c8e.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/85.wav
// module id = lfPe
// module chunks = 0